/**
 * ViewMenu — Refresh, Theme, Fullscreen. View-state toggles only; section
 * navigation lives in the left sidebar so the Section sub-menu was removed
 * (1:1 duplicate of GlobalNavigation).
 */
import React, { useState } from 'react';
import {
  Divider,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Radio,
} from '@mui/material';
import {
  Brightness4,
  ChevronRight,
  DarkMode,
  Fullscreen,
  LightMode,
  Refresh,
} from '@mui/icons-material';
import { useTheme as useAppTheme } from '../../../context/ThemeContext';

const ViewMenu = ({
  anchorEl,
  open,
  onClose,
  onRefresh,
  onToggleFullscreen,
}) => {
  const { themeMode, setTheme } = useAppTheme();
  const [themeAnchor, setThemeAnchor] = useState(null);

  const closeAll = () => {
    setThemeAnchor(null);
    onClose();
  };

  const wrap = (fn) => () => { closeAll(); fn?.(); };

  const handleTheme = (mode) => {
    setTheme(mode);
    closeAll();
  };

  return (
    <>
      <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
        <MenuItem onClick={wrap(onRefresh)} dense>
          <ListItemIcon><Refresh fontSize="small" /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
            Refresh
          </ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem
          dense
          onClick={(e) => setThemeAnchor(e.currentTarget)}
          aria-haspopup="true"
        >
          <ListItemIcon><Brightness4 fontSize="small" /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
            Theme
          </ListItemText>
          <ChevronRight fontSize="small" />
        </MenuItem>
        <Divider />
        <MenuItem onClick={wrap(onToggleFullscreen)} dense>
          <ListItemIcon><Fullscreen fontSize="small" /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
            Full Screen
          </ListItemText>
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={themeAnchor}
        open={Boolean(themeAnchor)}
        onClose={() => setThemeAnchor(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem dense onClick={() => handleTheme('light')}>
          <ListItemIcon><LightMode fontSize="small" /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
            Light
          </ListItemText>
          <Radio size="small" checked={themeMode === 'light'} />
        </MenuItem>
        <MenuItem dense onClick={() => handleTheme('dark')}>
          <ListItemIcon><DarkMode fontSize="small" /></ListItemIcon>
          <ListItemText primaryTypographyProps={{ fontSize: '0.875rem' }}>
            Dark
          </ListItemText>
          <Radio size="small" checked={themeMode === 'dark'} />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ViewMenu;
